import { Button as Btn, ButtonProps } from '@yt/fe-shared'
import styles from './index.module.scss'
import React from 'react'
import omit from 'lodash/omit'
import cn from 'classnames'

const Button: React.FC<ButtonProps> = (props: ButtonProps) => {
  const type = props.type || 'primary'

  const classsNameMap: any = {
    primary: styles.primary,
    default: styles.default
  }

  if (type === 'link') {
    const btnClassNames = cn(
      styles.link,
      {
        [styles.disabled]: props.disabled
      },
      props.className
    )

    return (
      <Btn
        useAntdStyle
        {...omit(props, 'children')}
        type={type}
        classTypeMap={classsNameMap}
        className={btnClassNames}
      >
        {' '}
        {props.children}
      </Btn>
    )
  }

  const btnClassNames = cn(
    styles.btn,
    {
      [styles.disabled]: props.disabled
    },
    props.className
  )

  return (
    <Btn
      {...omit(props, 'children')}
      type={type}
      classTypeMap={classsNameMap}
      className={btnClassNames}
    >
      {' '}
      {props.children}
    </Btn>
  )
}

export default Button
